import { Box, Card } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ETheme } from '../../../shared/enums/user/ETheme';
import { getRGBAColor } from '../../../shared/functions/getRGBAColor';
import { handleError } from '../../../shared/functions/handleError';
import { handleNotificationClick } from '../../../shared/functions/handleNotificationClick';
import { usePagination } from '../../../shared/hooks/usePagination';
import { INotifications } from '../../../shared/interfaces/notifications/INotifications';
import { IUser } from '../../../shared/interfaces/user/IUser';
import { darkPalette, lightPalette } from '../../../shared/mui/palettes';
import { RootState } from '../../../store/store';
import NotificationItem from './components/NotificationItem';
import { AdminNotificationService } from './service';

const AdminNotifications = () => {
  const dispatch = useDispatch();
  const authState = useSelector((state: RootState) => state.auth);
  const [notifications, setNotifications] = useState<INotifications[]>([]);
  const { pagination, setPagination } = usePagination({ perPage: 20 });
  const { userData } = useSelector((state: RootState) => state.auth);
  const correctPalette =
    userData?.theme === ETheme.LIGHT ? lightPalette : darkPalette;
  const navigate = useNavigate();

  useEffect(() => {
    AdminNotificationService.getAll(pagination)
      .then((response) => {
        setNotifications(response?.data);
      })
      .catch((err) => handleError(err));
  }, [pagination]);
  return (
    <Card sx={{ marginRight: '20px', cursor: 'pointer' }}>
      {notifications?.map((notification) => {
        return (
          <Box
            key={notification?.id}
            onClick={() =>
              handleNotificationClick(
                notification,
                userData as IUser,
                navigate,
                setPagination,
                dispatch,
                authState,
              )
            }
            sx={{
              borderBottom: `1px solid ${getRGBAColor('--primaryColor', 0.08)}`,
              background: notification.isSeen
                ? correctPalette.background.default
                : getRGBAColor('--primaryColor', 0.08),
              position: 'relative',
              padding: '10px',
            }}
          >
            <NotificationItem
              notification={notification}
              correctPalette={correctPalette}
              isDetail={true}
            />
          </Box>
        );
      })}
    </Card>
  );
};

export default AdminNotifications;
